import { CustomerLayout } from './customer-layout';

export function CustomerLayoutWrapper() {
  return <CustomerLayout />;
}
